import { useCallback, useState } from 'react';

import type { MeetingJoinSettings } from './types';
import { defaultMeetingJoinSettings } from './types';

export type UseMeetingLobbyStateOptions = {
  initialLobbyDone?: boolean;
  initialJoinSettings?: MeetingJoinSettings;
};

/** Persists lobby device choices across rejoin (parent-owned state). */
export function useMeetingLobbyState(options?: UseMeetingLobbyStateOptions) {
  const [lobbyDone, setLobbyDone] = useState(options?.initialLobbyDone ?? false);
  const [joinSettings, setJoinSettings] = useState<MeetingJoinSettings>(
    options?.initialJoinSettings ?? defaultMeetingJoinSettings,
  );

  const onLobbyJoin = useCallback((settings: MeetingJoinSettings) => {
    setJoinSettings(settings);
    setLobbyDone(true);
  }, []);

  return { lobbyDone, joinSettings, onLobbyJoin };
}
